import { AppShell } from './AppShell';
import { router } from './router';

// Bundle COMBINADO (público + CRM en un solo deploy) — backward compat.
// Las apps separadas del split usan main.public / main.crm / main.booster.
export default function App() {
  return <AppShell router={router} />;
}
